import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { reduxForm, submit, destroy as destroyForm, formValueSelector } from 'redux-form'
import { translate } from 'loankeeper-common/helpers'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import LKModal, { LKModalContainer, LKModalTrigger, actions as LKModalActions } from '../../LKModal'
import ClientDetailsTabView from '../../../OrderAdd/partials/ClientDetailsTabView'
import { maskForRequiredFields, DropdownNames } from '../../../OrderAdd/constants'
import { getClientReqFields, getClientSelects } from 'src/store/client'

export const MODAL_NAME = 'ClientDetailsModal'

const FORM_NAME = 'LoanAccDisburseClientDetails'

@reduxForm({
  form: FORM_NAME,

  destroyOnUnmount: false,

  onSubmitFail: (errors, dispatch) => {
    dispatch(LKModalActions.openError(translate('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS')))
  },

  validate: (values, { requiredFields, OpenDay }) => {
    const errors = {}

    if (!values.Client || !values.IDDoc) {
      errors._error = 'Select Client!'
    }

    if (moment(values.IDCardRegDate, 'DD.MM.YYYY').isAfter(moment(OpenDay, 'DD.MM.YYYY'))) {
      errors.IDCardRegDate = 'invalid'
    }

    if (moment(values.IDValidityDate, 'DD.MM.YYYY').isBefore(moment(OpenDay, 'DD.MM.YYYY'))) {
      errors.IDValidityDate = 'invalid'
    }

    if (values.IDCardRegDate && !LKDate.isValid(values.IDCardRegDate)) {
      errors.IDCardRegDate = 'invalid'
    }

    if (values.IDValidityDate && !LKDate.isValid(values.IDValidityDate)) {
      errors.IDValidityDate = 'invalid'
    }

    if (
      values.IDCardRegDate &&
      values.IDValidityDate &&
      moment(values.IDCardRegDate, 'DD.MM.YYYY').isAfter(moment(values.IDValidityDate, 'DD.MM.YYYY'))
    ) {
      errors.IDCardRegDate = 'invalid'
    }

    Object.keys(requiredFields).forEach((key) => {
      const fieldName = maskForRequiredFields[key]

      if (requiredFields[key].Active === 1) {
        if (!DropdownNames.includes(key)) {
          if (!values[fieldName]) {
            errors[fieldName] = translate('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS') // 'required'
          }
        } else if (parseInt(values[fieldName], 10) === 1) {
          errors[fieldName] = translate('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS') // 'required'
        }
      }
    })

    return errors
  },

  onSubmit: (values, dispatch, ownProps) => {
    if (ownProps.onSuccess) ownProps.onSuccess(values)

    ownProps.closeModal()

    return Promise.resolve()
  },
})
class ClientDetailsForm extends React.Component {
  render() {
    const {
      change,
      OpenDay,
      clearFields,
      requiredFields,
      clientSelects,
      client,
      initialValues,
      disableHandfill,
      initialClient,
      initialIDDoc,
      initialDelegate,
    } = this.props
    initialValues.IDCardRegDate = dateFormatter(initialValues.IDCardRegDate)
    initialValues.DOB = dateFormatter(initialValues.DOB)
    initialValues.IDValidityDate = dateFormatter(initialValues.IDValidityDate)

    return (
      <ClientDetailsTabView
        change={change}
        requiredFields={requiredFields}
        clientSelects={clientSelects}
        OpenDay={OpenDay}
        disableInputs={false}
        cashOut
        clearFields={clearFields}
        form={FORM_NAME}
        client={client}
        initialValues={initialValues}
        disableHandfill={disableHandfill}
        initialClient={initialClient}
        initialIDDoc={initialIDDoc}
        initialDelegate={initialDelegate}
        embedded
      />
    )
  }
}

@LKModalContainer(MODAL_NAME)
@connect(
  (state) => ({
    Client: formValueSelector(FORM_NAME)(state, 'Client'),
  }),
  {
    submit,
    destroyForm: () => destroyForm(FORM_NAME),
  },
)
@connect(undefined, (dispatch) => ({
  getClientReqFields: (params) => dispatch(getClientReqFields(params)),
  getClientSelects: (params) => dispatch(getClientSelects(params)),
}))
class ClientDetailsModal extends React.Component {
  state = { loading: true }

  componentDidMount() {
    this.fetchData()
  }

  fetchData = async () => {
    // this.clientLookups = Client.getSelects()
    //UPDATED API REQUEST client_lookups_api
    this.clientLookups = this.props.getClientSelects()

    // const response = await Client.getRequiredFields({ groupid: 9, typeid: this.props.client.typeID })
    //UPDATED API REQUEST client_reqfields_api
    const { payload: response } = await this.props.getClientReqFields({ groupid: 9, typeid: this.props.client.typeID })

    this.requiredFields = response.ReqFields.reduce(
      (result, current) => ({
        ...result,
        [current.FName]: current,
      }),
      {},
    )
    this.clientLookups = (await this.clientLookups).payload

    this.setState({ loading: false })
  }

  handleSubmit = () => {
    this.props.submit(FORM_NAME)
  }

  handleClose = () => {
    this.props.destroyForm()
    this.props.closeModal()
  }

  render() {
    const {
      modalInstanceName,
      change,
      OpenDay,
      clearFields,
      client,
      onSuccess,
      initialValues,
      disableHandfill,
      initialClient,
      initialIDDoc,
      initialDelegate,
    } = this.props

    const { loading } = this.state

    return (
      <LKModal
        name={modalInstanceName}
        onClose={this.props.destroyForm}
        loading={loading}
        size="medium"
        footer={
          <LKModal.Footer>
            <LKBaseButton.Okay onClick={this.handleSubmit} disabled={!this.props.Client} />
          </LKModal.Footer>
        }
      >
        <ClientDetailsForm
          change={change}
          requiredFields={this.requiredFields}
          clientSelects={this.clientLookups}
          OpenDay={OpenDay}
          disableInputs={false}
          cashOut
          clearFields={clearFields}
          form={FORM_NAME}
          closeModal={this.handleClose}
          client={client}
          onSuccess={onSuccess}
          initialValues={initialValues}
          disableHandfill={disableHandfill}
          initialClient={initialClient}
          initialIDDoc={initialIDDoc}
          initialDelegate={initialDelegate}
        />
      </LKModal>
    )
  }
}

const ClientDetailsModalTrigger = ({
  change,
  OpenDay,
  clearFields,
  children,
  params,
  onSuccess,
  initialValues,
  client,
  disabled,
  disableHandfill,
  initialClient,
  initialIDDoc,
  initialDelegate,
}) => (
  <>
    <LKModalTrigger name={MODAL_NAME} alias="users" params={params} disabled={disabled}>
      {children}
    </LKModalTrigger>

    <ClientDetailsModal
      OpenDay={OpenDay}
      clearFields={clearFields}
      client={client}
      change={change}
      onSuccess={onSuccess}
      initialValues={initialValues}
      disableHandfill={disableHandfill}
      initialClient={initialClient}
      initialIDDoc={initialIDDoc}
      initialDelegate={initialDelegate}
    />
  </>
)

export default ClientDetailsModalTrigger
